import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import { run, delay, SAS, isString } from '@fexd/tools';
var requestSuccess = false;
export var init = SAS( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var readyPromise, scriptPromise;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readyPromise = new _Promise(function (resolve) {
              window._smReadyFuncs = [function () {
                requestSuccess = true;
                var latestDeviceId = run(window, 'SMSdk.getDeviceId');
                resolve(latestDeviceId);
              }];
            });
            scriptPromise = new _Promise(function (resolve) {
              var organization = params.organization,
                  appId = params.appId,
                  publicKey = params.publicKey,
                  staticHost = params.staticHost,
                  protocol = params.protocol,
                  apiHost = params.apiHost,
                  fpJsPath = params.fpJsPath;
              window._smConf = _objectSpread(_objectSpread({}, params), {}, {
                organization: organization,
                //必填，组织标识，邮件中 organization 项
                appId: appId,
                //必填，应用标识，默认传值 default，其他应用标识提前联系数美协助定义
                publicKey: publicKey,
                //必填，私钥标识，邮件中 publicKey 项
                staticHost: staticHost,
                //必填, 设置 JS-SDK 文件域名
                protocol: protocol,
                // 如果使用 https，则设置，如不使用，则不设置这个字段
                fpJsPath: fpJsPath
              });

              var src = function () {
                var originHost = 'static.fengkongcloud.com';
                var isHttps = 'https:' === document.location.protocol;
                var protocol = isHttps ? 'https://' : 'http://';
                var fpJsPath = '/dist/web/v3.0.0/fp.min.js';
                var jsTimer = '?t=' + (new Date().getTime() / (6 * 3600 * 1000)).toFixed(0);
                var url = protocol + window._smConf.staticHost + window._smConf.fpJsPath + jsTimer;
                var ua = navigator.userAgent.toLowerCase();
                var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
                var isLowIE = /msie\s[678]\.0/.test(ua);

                if (isHttps && isWinXP && isLowIE) {
                  url = protocol + originHost + fpJsPath + jsTimer;
                }

                return url;
              }();

              var scriptDom = document.getElementById('sm_js_script');
              if (scriptDom) scriptDom.parentNode.removeChild(scriptDom);
              var sm = document.createElement('script');
              sm.src = src;
              sm.setAttribute('id', 'sm_js_script');
              document.head.appendChild(sm);

              sm.onload = function () {
                setTimeout(function () {
                  var cacheDeviceId = run(window, 'SMSdk.getDeviceId');
                  resolve(cacheDeviceId);
                }, 16);
              };
            });
            _context.next = 4;
            return _Promise.all([_Promise.race([readyPromise, delay(2000)]), scriptPromise]);

          case 4:
            return _context.abrupt("return", run(window, 'SMSdk.getDeviceId'));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export var fetchDeviceId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var _window, _window$SMSdk, _window2, _window2$SMSdk;

    var inited, deviceId, success;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            inited = typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$SMSdk = _window.SMSdk) === null || _window$SMSdk === void 0 ? void 0 : _window$SMSdk.getDeviceId) === 'function';

            if (inited) {
              _context2.next = 4;
              break;
            }

            _context2.next = 4;
            return init(params);

          case 4:
            deviceId = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$SMSdk = _window2.SMSdk) === null || _window2$SMSdk === void 0 ? void 0 : _window2$SMSdk.getDeviceId();
            success = isString(deviceId);

            if (success) {
              _context2.next = 9;
              break;
            }

            console.error('请检查数美配置是否正确');
            return _context2.abrupt("return", {
              success: false,
              data: null
            });

          case 9:
            return _context2.abrupt("return", {
              success: true,
              data: {
                fromRemote: requestSuccess,
                deviceId: deviceId
              }
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchDeviceId(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchDeviceId;